import { DefaultRouteTabs } from '@/components/_common';
import { useDisclosure } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Button, Divider } from 'antd';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import InvoiceButtonsRepeated from '../InvoiceButtonsRepeated';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import NfsDeductionModalForm from '@/components/Fiscal/Invoice/NfsDeductions/NfsDeductionModalForm';
import InvoiceDeductionNFSETable from '@/components/Fiscal/Invoice/NfsDeductions/InvoiceDeductionNFSETable';
import { InvoiceSituation } from '@/core/domain/invoice/invoices/invoices.enums';
import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import invoiceValidateRoutes from '../../Invoice.validateRoutes';

export default function InvoiceNfsDeductionsPage({ route }: PageProps) {
  const {
    invoiceId,
    invoice: { data: invoice },
  } = useInvoiceFormContext();

  const [modalCreateDeductionOpened, modalCreateDeductionAction] =
    useDisclosure();

  const { pathname } = useLocation();
  const URL = '/' + pathname.split('/').slice(1, -1).join('/');

  const disabledFields = invoice?.situation !== InvoiceSituation.IN_TYPING;

  return (
    <>
      <DefaultRouteTabs
        route={invoiceValidateRoutes(route, invoice?.situation)}
        baseKey={invoiceId}
        basePath={URL}
        permissions={route.permissions}
      >
        <Helmet title="Deduções" />

        <SpaceForButton justifyContent="end">
          <Button
            type="primary"
            onClick={modalCreateDeductionAction.open}
            disabled={disabledFields}
          >
            Nova Dedução
          </Button>
        </SpaceForButton>

        <Divider />

        <InvoiceDeductionNFSETable
          invoiceId={Number(invoiceId)}
          disabledFields={disabledFields}
        />

        <Divider />

        <InvoiceButtonsRepeated />
      </DefaultRouteTabs>

      <NfsDeductionModalForm
        open={modalCreateDeductionOpened}
        onCancel={modalCreateDeductionAction.close}
        onOk={() => null}
        invoiceId={Number(invoiceId)}
      />
    </>
  );
}
